<mat-form-field appearance="outline" (click)="showMe()" [formGroup]="formGroup">
  <mat-label>Frequency</mat-label>
  <input matInput readonly formControlName="frequencyDisplay" />
  <mat-icon matSuffix>expand_more</mat-icon>
</mat-form-field>
